// Color Constants
// Centralized color palette for consistent theming across the application

export const COLORS = {
  // Primary brand colors
  primary: '#0A0F1C',
  secondary: '#1E3A5F',
  accent: '#3B82F6',

  // Accent colors
  gold: '#F59E0B',
  sage: '#10B981',

  // Background colors
  pearl: '#F8FAFC',
  mist: '#F1F5F9',

  // Text colors
  charcoal: '#334155',
  smoke: '#64748B',

  // Gray scale
  gray100: '#F3F4F6',
  gray200: '#E5E7EB',
  gray300: '#D1D5DB',
  gray400: '#9CA3AF',
  gray500: '#6B7280',
  gray600: '#4B5563',
  gray700: '#374151',
  gray800: '#1F2937',
  gray900: '#111827',

  // Semantic colors
  success: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
  info: '#3B82F6',

  // Risk profiler colors
  riskConservative: '#22c55e',
  riskCautious: '#eab308',
  riskBalanced: '#f97316',
  riskGrowth: '#dc2626',
  riskAggressive: '#b91c1c',

  // White and black
  white: '#FFFFFF',
  black: '#000000',
} as const;

// Type for color keys
export type ColorKey = keyof typeof COLORS;
